(function () {
  function applyFade() {
    document.querySelectorAll('product-card').forEach(function (card) {
      if (card._fadeBound) return;

      const slideshow = card.querySelector('slideshow-component');
      if (!slideshow || typeof slideshow.select !== 'function') return;

      card._fadeBound = true;

      const originalSelect = slideshow.select.bind(slideshow);

      slideshow.select = async function (input, event, options = {}) {
        const slides = Array.from(slideshow.querySelectorAll('slideshow-slide'));
        if (slides.length < 2) return originalSelect(input, event, options);

        const scroller = slideshow.querySelector('[ref="scroller"]') || slideshow.firstElementChild;

        // Only fade to 0.1 (never fully transparent = no white flash)
        scroller.style.transition = 'opacity 0.10s ease-in-out';
        scroller.style.opacity = '0.1';

        await new Promise(r => setTimeout(r, 50));

        const result = await originalSelect(input, event, { ...options, animate: false });

        scroller.style.opacity = '1';

        await new Promise(r => setTimeout(r, 50));
        scroller.style.transition = '';

        return result;
      };
    });
  }

  let attempts = 0;
  const interval = setInterval(function () {
    applyFade();
    attempts++;
    if (attempts >= 20) clearInterval(interval);
  }, 300);
})();
